import PropTypes from 'prop-types'
import React from 'react'

import { Tooltip } from 'react-wot-bootstrap'

import { getMinutesAndSecondsFormat } from 'helpers/datetime'

import { ROUND_RESULT_MESSAGES, ROUND_SCORE_TITLE } from 'helpers/i18n.jsx'

import { FORT_BATTLE_SERIES_RESULT, FORT_BATTLE_SERIES_FINISH_REASONS } from 'constants'
import { ROUND_RESULT_TITLES } from './constants.jsx'

import styles from './RoundResultTooltip.scss'

export class RoundResultTooltip extends React.Component {
    static propTypes = {
        tooltipId: PropTypes.string.isRequired,
        roundResult: PropTypes.object.isRequired,
    }

    getTitle() {
        const { roundResult } = this.props
        let result = (roundResult.is_win ? FORT_BATTLE_SERIES_RESULT.VICTORY :
            (roundResult.is_draw ? FORT_BATTLE_SERIES_RESULT.DRAW : FORT_BATTLE_SERIES_RESULT.DEFEAT)).toUpperCase()

        // FIRST BATTLE_
        if (!roundResult.fort_battle_state) {
            return ROUND_RESULT_TITLES[`FIRST_BATTLE_${result}`]
        }

        const point = roundResult.fort_battle_state.findIndex(battle => battle.attacker_clan_id !== null)

        /* 0 - 1 - 2 - 3 - 4 - 5
        own citadel - own back line - own front line - enemy front line - enemy back line - enemy citadel
        */

        switch (point) {
        case 0:
            return ROUND_RESULT_TITLES[`CITADEL_OWN_${result}`]
        case 1:
            return ROUND_RESULT_TITLES[`BACK_LINE_OWN_${result}`]
        case 2:
            return ROUND_RESULT_TITLES[`FRONT_LINE_OWN_${result}`]
        case 3:
            return ROUND_RESULT_TITLES[`FRONT_LINE_ENEMY_${result}`]
        case 4:
            return ROUND_RESULT_TITLES[`BACK_LINE_ENEMY_${result}`]
        case 5:
            return ROUND_RESULT_TITLES[`CITADEL_ENEMY_${result}`]
        }
    }


    getMessage() {
        const { roundResult } = this.props
        const isTimeoutFinish = roundResult.finish_reason === FORT_BATTLE_SERIES_FINISH_REASONS.TIMEOUT
        const result = (roundResult.is_win ? FORT_BATTLE_SERIES_RESULT.VICTORY :
            (roundResult.is_draw ? FORT_BATTLE_SERIES_RESULT.DRAW : FORT_BATTLE_SERIES_RESULT.DEFEAT)).toUpperCase()

        const key = isTimeoutFinish ? roundResult.finish_reason : `${roundResult.finish_reason}_${result}`

        const durationMinutes = Math.floor(roundResult.battle_duration / 60)
        const durationSeconds = roundResult.battle_duration % 60
        return ROUND_RESULT_MESSAGES[key](getMinutesAndSecondsFormat(durationMinutes, durationSeconds))
    }

    render() {
        return (
            <Tooltip id={this.props.tooltipId} offset={{ top: 0, left: 100 }}>
                <div className={styles.tooltipContent}>
                    <h3 className={styles.tooltipTitle}>{this.getTitle()}</h3>
                    <p className={styles.tooltipMessage}>{this.getMessage()}</p>
                    <p className={styles.tooltipMessage}>
                        {ROUND_SCORE_TITLE}
                        {': '}
                        <span className={styles.score}>{this.props.roundResult.score.join(' : ')}</span>
                    </p>
                </div>
            </Tooltip>
        )
    }
}

export default RoundResultTooltip



// WEBPACK FOOTER //
// ./containers/PostbattleScreen/components/RoundResultTooltip/RoundResultTooltip.jsx